import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BarCodeCategory, InteractionType, KeyValueSet, KeyValueSetInt, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, StartUpType, TriggeredEvent } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-bulk-qr-code',
  templateUrl: './bulk-qr-code.component.html',
  styleUrls: ['./bulk-qr-code.component.scss']
})
export class BulkQrCodeComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["barcode"]; printWidth: number = 200;
  @Input() productId = '0'; @Input() businessId = '0'; @Input() valuesDisplayValues: KeyValueSet[];
  maxBodyHeight = 0; barCodeSize: number = 200; @Input() countryCode = '';
  @Input() categoryCode: BarCodeCategory = BarCodeCategory.None;
  IsPrint: boolean = false; FileName: string = ''; printContent: string = '';
  numericConfig: NumericConfig = { isDecimalAllowed: true, maxValue: 1000 } as NumericConfig;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onSetLastUsedSettings();
    if (this.valuesDisplayValues.length > 0) {
      this.valuesDisplayValues[0].isSelected = true;
    }
  }

  onGetValue(valueDisplayValue: KeyValueSet): string {
    let values: string[] = [];
    if (this.categoryCode == BarCodeCategory.None) {
      values.push(valueDisplayValue.key);
    } else {
      values.push(this.localService.barCodePrefix);
      values.push(this.localService.getLoginAsCountryCode() );
      values.push(this.categoryCode.toString());
      values.push(valueDisplayValue.key);
      values.push('1');
      values.push(this.businessId);
      values.push(this.productId);
      values.push(InteractionType.Business.toString());
    }
    let barcodeValue = (this.categoryCode != BarCodeCategory.None ? environment.url.app : '') + values.join(this.localService.barcodeSplitChar);
    return barcodeValue;
  }

  count = 0;
  onPrint() {
    this.onSetLastUsedSettings();
    this.FileName = 'qrCode_' + this.businessId + '_' + this.productId;
    this.printContent = '';
    this.count = 0;
    this.onAddPrint();
  }

  onAddPrint() {
    setTimeout(() => {
      let valueDisplayValue = this.valuesDisplayValues[this.count];
      this.valuesDisplayValues.find(x => x.key == valueDisplayValue.key).isSelected = true;
      setTimeout(() => {
        this.count++;

        let qrcode_container = document.getElementById('qrcode_container_' + valueDisplayValue.key);
        if (qrcode_container) {
          let canvas = qrcode_container.getElementsByTagName('img')[0] as HTMLElement;
          if (canvas) {
            this.printContent += "<div><img style='width:" + this.barCodeSize + "px;height:" + this.barCodeSize + "px;' src = '" + canvas.getAttribute('src') + "'/></div>";
            if (valueDisplayValue.value != '') {
              this.printContent += "<div>" + valueDisplayValue.value + "</div>";
            }
          }
        }
        if (this.count == this.valuesDisplayValues.length) {
          this.IsPrint = true;
          this.activeModal.close({ event: TriggeredEvent.Ok });
        } else {
          this.valuesDisplayValues.find(x => x.key == valueDisplayValue.key).isSelected = false;
          this.onAddPrint();
        }
      }, 10);
    }, 10);
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onGetBusinessId(): string | undefined {
    let businessId: string | undefined = undefined;
    if (this.businessId && this.businessId != '0')
      businessId = this.businessId;
    return businessId;
  }

  onSetLastUsedSettings() {
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != '') {
      this.barCodeSize = parseFloat(temp);
    }
  }

  onSaveLastUsedSettings() {
    if (!this.barCodeSize)
      this.barCodeSize = 200;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != this.barCodeSize.toString())
      items.push({ keyType: LastUsedSettingsType.QrPrintSize, value: this.barCodeSize.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }

}
